export interface Configurations {
  bed: number
  study: number
  bath: number
  powderRoom: number
  car: number
}

export interface MinMaxInterface {
  max: string
  min: string
}

export enum PropertyType {
  Unit = 'unit',
  Lot = 'lot',
}

export enum Role {
  BUYER = 'buyer',
  USER = 'user',
  AGENT = 'agent',
  PARTNER_AGENT = 'partner-agent',
  SUPER_ADMIN = 'super-admin',
  ADMIN = 'admin',
}
